import { CancelSubscriptionStatus } from '@models/membership/Subscription'
import { useAppSelector } from '@store/hooks'
import { selectSelectedSubscription } from '@store/membership/SubscriptionReducer'
import { SBRM, SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { matchValueRule, requiredRule } from '@utils/rules'
import { Form, Input, Radio, Typography } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const { Text } = Typography

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedSubscription())

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item)
    }
  }, [item])

  if (item === undefined) {
    return <></>
  }

  const confirmText = 'I confirm cancellation'

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>

      <SBRM.FormSection section="cancellation">
        <Form.Item
          name="status"
          label={'Cancel subscription'}
          rules={[
            requiredRule(),
            {
              validator: (_, value) => {
                const allowed: CancelSubscriptionStatus[] = [
                  'cancelled',
                  'to_cancel',
                ]
                return allowed.includes(value)
                  ? Promise.resolve()
                  : Promise.reject('Incorrect value')
              },
            },
          ]}
        >
          <Radio.Group
            vertical
            options={[
              {
                value: 'cancelled',
                label: `Immediately (${dayjs().format('MMMM DD, YYYY')})`,
              },
              {
                value: 'to_cancel',
                label: `End of current period (${dayjs(item.renewalDate).format('MMMM DD, YYYY')})`,
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          label={
            <Text strong>To confirm, please type below "{confirmText}".</Text>
          }
          name="confirm"
          rules={[requiredRule(), matchValueRule(confirmText)]}
        >
          <Input />
        </Form.Item>
      </SBRM.FormSection>
    </Form>
  )
}

export default Update
